<app-tourism-calendar-event-filters
	userFilters="tourismCalendar"
	[categories]="parameters.category"
	[statuses]="parameters.status"
	[yesno]="parameters.yesno"
	[vehicle_busTypes]="parameters.vehicle_busType"
	[vehicle_statuses]="parameters.vehicle_status"
	[users]="users"
	(selected)="filtersSelected($event)"
></app-tourism-calendar-event-filters>

<app-tourism-calendar-event-view
	[selectedObject]="selectedObject"
	[vehicles]="vehicles"
	[drivers]="drivers"
	[touristGuides]="touristGuides"
	[users]="users"
	[parameters]="parameters"
	(eventClosed)="eventClosed($event)"
	(reloadTourismData)="loadData()"
></app-tourism-calendar-event-view>

<app-events-timeline
	[module]="'tourismCalendar'"
	[date_from]="date_from"
	[date_to]="date_to"
	[data]="data"
	addLink="/tourism-events/add/"
	(filtersClicked)="filtersOpen()"
	(eventClicked)="eventOpen($event)"
></app-events-timeline>

<div id="legend" class="d-flex flex-column">
	<div class="btn-group flex-column" *ngIf="showLegend">
		<button type="button" class="btn" style="background: #797777; color: #ffffff">
			Osobowe, Marketing, Pracownicze
		</button>
		<button type="button" class="btn" style="background: #38a439; color: #ffffff">Inne</button>
		<button type="button" class="btn" style="background: #745509; color: #ffffff">Postój</button>
		<button type="button" class="btn" style="background: #dfa50d">Serwis</button>
		<button type="button" class="btn" style="background: #0ddfce">Na pusto</button>
		<button type="button" class="btn" style="background: #0d259c; color: #ffffff">Oskar</button>
		<button type="button" class="btn" style="background: #4890c8; color: #ffffff">Wynajem</button>
		<button type="button" class="btn" style="background: #980d9c; color: #ffffff">Wynajem zagraniczny</button>
		<button type="button" class="btn" style="background: #ed6a24; color: #ffffff">Wynajem Grupa</button>
		<button type="button" class="btn" style="background: #df1d0d; color: #ffffff">Niezgodność</button>
		<button type="button" class="btn" style="background: #f0ff19; color: #000000">Wynajem LDC Skandynawia</button>
		<button type="button" class="btn" style="background: #005429; color: #ffffff">Antenka autokar</button>
		<button type="button" class="btn" style="background: #7d2de7; color: #ffffff">Awaria</button>
		<button type="button" class="btn" style="background: #5474ff; color: #ffffff">Myjnia</button>
	</div>
	<button type="button" class="btn btn-info" (click)="showLegend = !showLegend">Legenda</button>
</div>
